import { render, staticRenderFns } from "./PDFViewFull.vue?vue&type=template&id=7297be9f&"
import script from "./PDFViewFull.vue?vue&type=script&lang=js&"
export * from "./PDFViewFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports